import { useEffect, useState } from 'react';

/**
 * ⭐ **O caminho da barra superior — sistema visual 2026, 14/09/2026.**
 *
 * A página diz onde se está ("Clientes / ESCRITÓRIO EXEMPLO"), e a barra
 * mostra. A trilha morava dentro de cada página, a meia altura; na barra ela
 * fica sempre no mesmo lugar.
 *
 * ⚠️ **A página que define, limpa ao sair.** Sem limpar, a trilha de uma
 * ficha ficaria na barra da tela seguinte — e a barra diria que se está onde
 * não se está.
 */
export type PassoDaTrilha = { rotulo: string; caminho?: string };

let atual: PassoDaTrilha[] = [];
const ouvintes = new Set<(t: PassoDaTrilha[]) => void>();

function publicar(t: PassoDaTrilha[]) {
  atual = t;
  ouvintes.forEach((o) => o(t));
}

/** A página declara o seu caminho enquanto está aberta. */
export function usarDefinirTrilha(passos: PassoDaTrilha[] | null) {
  const chave = passos ? JSON.stringify(passos) : '';
  useEffect(() => {
    if (!chave) return;
    publicar(JSON.parse(chave) as PassoDaTrilha[]);
    return () => publicar([]);
  }, [chave]);
}

export function usarTrilha(): PassoDaTrilha[] {
  const [t, setT] = useState(atual);
  useEffect(() => {
    ouvintes.add(setT);
    return () => {
      ouvintes.delete(setT);
    };
  }, []);
  return t;
}
